<script setup>
import { onMounted, ref, nextTick } from "vue";

const props = defineProps({ blok: Object, centralText: Boolean });

const showPost = ref(false);
const embedContainer = ref(null);

// Function to check if Twitter script is already loaded
const isTwitterScriptLoaded = () => {
  return window.twttr || document.querySelector('script[src="https://platform.twitter.com/widgets.js"]');
};

// Function to load Twitter script
const loadTwitterScript = () => {
  return new Promise((resolve) => {
    if (isTwitterScriptLoaded()) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;
    script.onload = () => {
      resolve();
    };
    document.head.appendChild(script);
  });
};

onMounted(async () => {
  console.log("X/Twitter component mounted");
  
  try {
    await loadTwitterScript();
    console.log("Twitter script loaded");
    
    // Wait for next tick to ensure DOM is ready
    await nextTick();
    
    // If window.twttr exists, process embeds
    if (window.twttr && window.twttr.widgets) {
      window.twttr.widgets.load();
    }
    
    showPost.value = true;
  } catch (error) {
    console.error("Error loading Twitter script:", error);
    // Show the embed anyway in case it works without the script
    showPost.value = true;
  }
});
</script>

<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col 
        v-if="centralText" 
        class="v-col-12 offset-0 v-col-sm-10 offset-sm-1 v-col-md-8 offset-md-2 v-col-lg-6 offset-lg-3 mt-0 mb-6 pb-0"
      >
        <div 
          v-if="showPost" 
          ref="embedContainer"
          class="d-flex justify-center" 
          v-html="blok.embed_blockquote"
        ></div>
      </v-col>
      <v-col 
        v-else 
        class="v-col-12 offset-0 v-col-sm-10 offset-sm-1 v-col-md-7 offset-md-5 mt-0 mb-6 pb-0"
      >
        <div 
          v-if="showPost" 
          ref="embedContainer"
          class="d-flex justify-center d-md-block" 
          v-html="blok.embed_blockquote"
        ></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
  iframe {
    border: none;
  }
  iframe body {
    background-color: transparent !important;
  }
  
  iframe #embed-video-container {
    background-color: transparent !important;
  }
</style>
